<template>
  <div class="page-wrapper pb-24 lg:pb-32">
    <MarkupSectionHeaderH1
      :config-data="{
        TitleFirstRow: modifiedConfigData.HeaderFirstRow.Title,
        TitleStyle: modifiedConfigData.HeaderFirstRow.TitleStyle,
        TitleSecondRow: modifiedConfigData.HeaderSecondRow.Title,
      }"
    />

    <MarkupSectionText
      v-if="modifiedConfigData.Ingress.Text"
      class="mt-16 md:mt-24"
      :config-data="modifiedConfigData.Ingress"
    />

    <MarkupUspWrapper
      class="mt-16 lg:mt-24"
      :config-data="modifiedConfigData.Usp"
    />
  </div>
  <div
    v-if="modifiedConfigData.Filter"
    class="page-wrapper pt-24 pb-8 lg:pb-16"
  >
    <MarkupFilterSection :config-data="modifiedConfigData.Filter" />
  </div>
</template>

<script lang="ts" setup>
interface Props {
  configData: {
    Header: {
      Row1?: string;
      Row2?: string;
    };
    Ingress: {
      Text?: string;
    };
    BulletList: {
      Bullet: {
        Row1: string;
        Row2: string;
      }[];
    };
    SliderSettings: {
      DefaultDownpaymentTime?: number;
      DefaultPlanId?: number;
    };
    FilterSettings?: {
      DefaultDownpaymentTime?: number;
      DefaultPlanId?: number;
    };
  };
}

const props = defineProps<Props>();

const modifiedConfigData = {
  HeaderFirstRow: {
    Title: props.configData.Header.Row1 ?? 'Mobiltelefoner',
    TitleStyle: 'boxed',
  },
  HeaderSecondRow: {
    Title: props.configData.Header.Row2,
    TitleStyle: 'boxed',
  },
  Ingress: {
    Text: props.configData.Ingress?.Text ?? '',
  },
  Usp: {
    Items: props.configData.BulletList.Bullet.map((item) => ({
      Icon: 'check-circle-white',
      Label: item.Row1,
      SubLabel: item.Row2,
    })),
  },
  Filter: props.configData.FilterSettings
    ? {
        Placeholder: 'Sök mobiltelefoner...',
        DrawerDescription:
          'Här kan du välja vilka mobiler du vill se och vad priset skall baseras på för abonnemang och delbetalning.',
        DefaultPlanId: props.configData.FilterSettings.DefaultPlanId,
        DefaultDownPayment:
          props.configData.FilterSettings.DefaultDownpaymentTime,
      }
    : undefined,
};
</script>

<style></style>
